<script lang="ts">
  import OneLayout from "../common/OneLayout.svelte";
  import StatsForPrint from "./StatsForPrint.svelte";
  import CanesForPrint from "./CanesForPrint.svelte";
  import OriginalDescr from "../common/OriginalDescr.svelte";
  import AboutPrint from "./AboutPrint.svelte";
  import PrintExplanation from "./PrintExplanation.svelte";

  export let pwtData: any;
  export let stats: any;

  const size = 200;
</script>

<main class="container">
  <section>
    <div class="title">Murano Fantasy by Pandelune</div>
    <span id="copyright">&copy; Copyright 2022, Pandelune.</span>
    <table>
      <tr>
        <td class="italic">
          <OriginalDescr />
        </td>
        <td id="thePwt">
          <OneLayout
            {size}
            resFactor={10}
            {pwtData}
            options={{ drawFlat: false, onlyOnce: true, showCanes: true }}
          />
        </td>
      </tr>
    </table>
  </section>

  <section>
    <div class="title">About the printed artwork</div>
    <PrintExplanation />
  </section>

  <section>
    <div class="title">List of canes and their properties</div>
    <div>
      The paperweight is composed of numerous <i>canes</i>. Each cane has
      properties, and is present a specific number of times in the
      paperweight.
    </div>
    <div>
      <CanesForPrint centers={pwtData.centers} {stats} />
    </div>
  </section>

  <section>
    <div class="title">Stats explained</div>
    <StatsForPrint {stats} />
  </section>

  <section>
    <div class="title">About the print</div>
    <AboutPrint />
  </section>

</main>

<style>
	#copyright {
		font-size: small;
		font-style:italic;
	}
</style>
